/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PressReleaseSuccessResponseData,
    PressReleaseSuccessResponseDataFromJSON,
    PressReleaseSuccessResponseDataFromJSONTyped,
    PressReleaseSuccessResponseDataToJSON,
} from './PressReleaseSuccessResponseData';

/**
 * POST /press_release
 * @export
 * @interface CreatePressReleaseResponse
 */
export interface CreatePressReleaseResponse {
    /**
     * 
     * @type {number}
     * @memberof CreatePressReleaseResponse
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof CreatePressReleaseResponse
     */
    message: string;
    /**
     * 
     * @type {PressReleaseSuccessResponseData}
     * @memberof CreatePressReleaseResponse
     */
    data: PressReleaseSuccessResponseData;
}

export function CreatePressReleaseResponseFromJSON(json: any): CreatePressReleaseResponse {
    return CreatePressReleaseResponseFromJSONTyped(json, false);
}

export function CreatePressReleaseResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePressReleaseResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': PressReleaseSuccessResponseDataFromJSON(json['data']),
    };
}

export function CreatePressReleaseResponseToJSON(value?: CreatePressReleaseResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': PressReleaseSuccessResponseDataToJSON(value.data),
    };
}

